module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epig"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("His magic is performed with complete naturalness, its artistry that of the art that conceals art. The consummate skill and technique is there but it is never displayed; it is, on the contrary, so carefully hidden that the performer is applauded not for his nimble-fingered dexterity but because he has, with the effortless ease of a real magician, exhibited a feat of what must be real magic.")])]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("—Jean Hugard and Frederick Braue, ")]), _vm._v("Expert Card Technique,"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(" Third Edition")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0